var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Sidebar'),_c('Content',{attrs:{"siteName":_vm.$route.params.siteName,"ccusSiteId":_vm.$route.params.ccusSiteId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }